import { FC, useEffect, useState } from 'react';
import './EditAlternativePassportData.scss';

import Button from 'components/common/ui-kit/Button';
import { InputV2 } from 'components/common/ui-kit/Input/view';
import useAppDispatch from 'hooks/common/useAppDispatch';
import useAppSelector from 'hooks/common/useAppSelector';
import { User } from 'models/enrollee';
import { hideModal } from 'redux/actions';
import { enrolleesApi } from 'redux/api/questionnaire/enrollees-api';
import { useUpdateAlternativePassportMutation } from 'redux/api/questionnaire/questionnaire-api';
import {
  selectCurrentApplication,
  selectCurrentQuestionnaire,
} from 'redux/selectors/staff/applications';
import { selectCurrentSupportQuestionnaire } from 'redux/selectors/staff/questionnaires';
import { staffApplicationsSlice } from 'redux/slices/staff/staffApplicationsSlice';
import { supportQuestionnaireSlice } from 'redux/slices/staff/supportQuestionnaireSlice';

import TemplateModal from '../TemplateModal';

const EditAlternativePassportData: FC = () => {
  const dispatch = useAppDispatch();
  const closeModal = () => dispatch(hideModal());
  const { isSupport } = useAppSelector(state => state.modal.data) || {};

  const editingData = useAppSelector(
    state => state.questionnaire.editingAlternativePassportData
  );
  const questionnaire = useAppSelector(
    isSupport ? selectCurrentSupportQuestionnaire : selectCurrentQuestionnaire
  );
  const application = useAppSelector(selectCurrentApplication);

  const [updateAlternativePassportData, { isLoading }] =
    useUpdateAlternativePassportMutation();
  const [triggerGetEnrollee] = enrolleesApi.useLazyGetByUserIdQuery();

  const userId = questionnaire?.user.id;

  const [identificationDocumentSerial, setDocumentSerial] = useState(
    editingData?.identificationDocumentSerial || ''
  );

  const [identificationDocumentNumber, setDocumentNumber] = useState(
    editingData?.identificationDocumentNumber || ''
  );

  const [identificationDocumentLastName, setLastName] = useState(
    editingData?.identificationDocumentLastName || ''
  );
  const [identificationDocumentFirstName, setFirstName] = useState(
    editingData?.identificationDocumentFirstName || ''
  );
  const [identificationDocumentMiddleName, setMiddleName] = useState(
    editingData?.identificationDocumentMiddleName || ''
  );

  useEffect(() => {
    if (editingData) {
      setDocumentSerial(editingData.identificationDocumentSerial);
      setDocumentNumber(editingData.identificationDocumentNumber);
      setLastName(editingData.identificationDocumentLastName);
      setFirstName(editingData.identificationDocumentFirstName);
      setMiddleName(editingData.identificationDocumentMiddleName);
    }
  }, [editingData]);

  const handleSave = async () => {
    if (!userId) {
      return;
    }

    try {
      await updateAlternativePassportData({
        userId,
        identificationDocumentSerial,
        identificationDocumentNumber,
        identificationDocumentLastName,
        identificationDocumentFirstName,
        identificationDocumentMiddleName,
      }).unwrap();

      const freshQuestionnaire = await triggerGetEnrollee(userId).unwrap();

      if (isSupport) {
        dispatch(
          supportQuestionnaireSlice.actions.setCurrentQuestionnaire(
            freshQuestionnaire
          )
        );
      } else {
        dispatch(
          staffApplicationsSlice.actions.setCurrentApplication({
            application: application!,
            questionnaire: freshQuestionnaire,
            user: userId ? ({ id: userId } as User) : undefined,
          })
        );
      }
      closeModal();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <TemplateModal title="Редактировать ФИО">
      <div className="passport-data-modal">
        <div className="passport-group">
          <label>Фамилия:</label>
          <InputV2
            type="string"
            value={identificationDocumentLastName}
            onChange={e => setLastName(e.target.value)}
          />

          <label>Имя:</label>
          <InputV2
            type="string"
            value={identificationDocumentFirstName}
            onChange={e => setFirstName(e.target.value)}
          />

          <label>Отчество:</label>
          <InputV2
            type="string"
            value={identificationDocumentMiddleName}
            onChange={e => setMiddleName(e.target.value)}
          />
        </div>
        <div className="action">
          <Button theme="success" onClick={handleSave} disabled={isLoading}>
            {isLoading ? 'Сохранение...' : 'Сохранить'}
          </Button>
        </div>
      </div>
    </TemplateModal>
  );
};

export default EditAlternativePassportData;
